import { AssetManager } from 'components/sharpr/assetManager/AssetManager';

export function VideoTranscriptionBetaConfirmationRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.VideoTranscriptionBetaConfirmation', {
		url: '/videoTranscriptionBetaConfirmation',
		controllerAs: 'vm',
		controller: VideoTranscriptionBetaConfirmationCtrl,
		templateUrl:
			'/ng/hub/VideoTranscription/BetaConfirmation/VideoTranscriptionBetaConfirmationCtrl.html?' + window.BUILD,
		resolve: {
			style: () =>
				AssetManager.css('/ng/hub/VideoTranscription/BetaConfirmation/VideoTranscriptionBetaConfirmationCtrl.css'),
			$title: () => 'VideoTranscriptionBetaConfirmation page',
		},
	});
}

export class VideoTranscriptionBetaConfirmationCtrl {
	closeModal() {
		if (this.$reject) {
			// from angular
			this.$reject();
		}
	}
}
